import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className='footer'>   
      <h2>Designed and developed</h2>
      <h3>by Nataliya Gapochka</h3>
      <a href="https://github.com/NG-SF" target="_blank" aria-label="link" rel="noopener noreferrer">GitHub</a>
    </footer>
  );
}
export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js